import script from "./SignUpRetailerPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SignUpRetailerPage.vue?vue&type=script&setup=true&lang=js"

import "./SignUpRetailerPage.vue?vue&type=style&index=0&id=7a952119&lang=scss"

const __exports__ = script;

export default __exports__